import { render, staticRenderFns } from "./plugin_action.vue?vue&type=template&id=90b7ad0a"
import script from "./plugin_action.vue?vue&type=script&lang=js"
export * from "./plugin_action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports